module.exports = __webpack_public_path__ + "static/screenshot_06@2x-2977fb1f1cc983c923cca69b2fe36ca5.png";